import React from 'react';
import logo from './logo.svg';
import './App.css';
import FullApp from './components/FullApp';

function App() {
  return (
    <div className="App">
      <FullApp/>
    </div>
  );
}

export default App;
